import { Component, Input } from '@angular/core';
import { Page, PagedData } from '@ca/core/models';

@Component({
    selector: 'ca-csv-table',
    templateUrl: './csv-table.component.html',
    styleUrls: ['./csv-table.component.scss'],
})
export class CsvTableComponent {
    @Input() set data(data: Object[]) {
        if (data != null) {
            this.columnNames = this.extractColumnHeadersFromCSV(data);
            this.setPage(data, 1);
            this._data = data;
        }
    }
    get data(): Object[] {
        return this._data;
    }

    columnNames = new Array<string>();
    page = new Page();
    rows = new Array<Object>();

    private _data: Object[];

    constructor() {
        this.page.pageNumber = 1;
        this.page.size = 20;
    }

    setPage(data: Object[], pageNumber: number): void {
        if (data != null) {
            this.page.pageNumber = pageNumber;
            const pagedData = this.getPagedData(data, this.page);
            this.page = pagedData.page;
            this.rows = pagedData.data;
        }
    }

    returnZero(): 0 {
        // this is needed because we do not want to sort what the keyvalue pipe is doing automatically
        return 0;
    }

    private extractColumnHeadersFromCSV(rows: Object[]): string[] {
        return Object.keys(rows[0]);
    }

    private getPagedData<T>(data: T[], page: Page): PagedData<T> {
        const pagedData = new PagedData<T>();
        pagedData.page = page;
        pagedData.page.totalElements = data.length;
        pagedData.page.totalPages = Math.ceil(page.totalElements / page.size);
        const start = (page.pageNumber - 1) * page.size;
        const end = Math.min(start + page.size, page.totalElements);
        for (let i = start; i < end; i++) {
            pagedData.data.push(data[i]);
        }
        return pagedData;
    }
}
